
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hK0fV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0644766e65bfc608$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $0644766e65bfc608$export$2e2bcd8739ae039 = {
    'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': "Con la tecnolog\xeda de Atlassian Intelligence",
    'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': "Con tecnolog\xeda de AI",
    'fabric.editor.ai.commandPalette.footer.disclaimerText': "El contenido se basa en tus permisos y es posible que su calidad var\xede",
    'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': 'La calidad del contenido puede variar',
    'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated': 'Utiliza IA. Verifica los resultados.',
    'fabric.editor.ai.commandPalette.footer.infoIconLabel': "Informaci\xf3n",
    'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
    'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': "Incluir los conocimientos de la p\xe1gina actual",
    'fabric.editor.ai.commandPalette.promptForm.logo': 'Logotipo de Atlassian Intelligence',
    'fabric.editor.ai.components.backIconButton.backLabel': "Atr\xe1s",
    'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Cancelar',
    'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
    'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Cancelar',
    'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Cancelar',
    'fabric.editor.ai.components.feedbackForm.badResponse': 'Mala respuesta',
    'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Comentarios enviados',
    'fabric.editor.ai.components.feedbackForm.goodResponse': 'Buena respuesta',
    'fabric.editor.ai.config.item.action.continueFromLatestResponse': "Continuar a partir de la \xfaltima respuesta",
    'fabric.editor.ai.config.item.action.copyResponse': 'Copiar',
    'fabric.editor.ai.config.item.action.responseCopied': "\xa1Copiado!",
    'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'Copiado en el portapapeles',
    'fabric.editor.ai.config.item.action.retryPrompt': 'Reintentar',
    'fabric.editor.ai.experience-application.documentInsertError': "Estamos teniendo problemas para insertar la respuesta. Cierra el di\xe1logo e int\xe9ntalo de nuevo.",
    'fabric.editor.ai.experience-application.tokenLimitExceeded': "No hemos obtenido respuesta. Tu mensaje o respuesta han superado el l\xedmite de esta solicitud. Cierra el di\xe1logo e int\xe9ntalo de nuevo.",
    'fabric.editor.ai.experience.apiError': "No hemos podido recibir una respuesta. Int\xe9ntalo de nuevo.",
    'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
    'fabric.editor.ai.experience.inputTooShortError': "El contenido es demasiado corto para resumirlo. A\xf1ade m\xe1s y vuelve a intentarlo.",
    'fabric.editor.ai.experience.loadingAriaTitle': 'Generando',
    'fabric.editor.ai.experience.previewScreenLabel': 'Vista previa',
    'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder': 'Pide al Agente que escriba algo o elige una de las siguientes opciones',
    'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
    'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Logotipo de Rovo',
    'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
    'fabric.editor.ai.screens.discard.cancelLabel': "Atr\xe1s",
    'fabric.editor.ai.screens.discard.discardLabel': 'Descartar',
    'fabric.editor.ai.screens.error.warningIconLabel': 'Advertencia',
    'fabric.editor.ai.screens.error.ariaErrorTitle': 'Error',
    'fabric.editor.ai.screens.error.cancelLabel': 'Cancelar',
    'fabric.editor.ai.screens.error.retryLabel': 'Volver a intentarlo',
    'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': "Contenido de actualizaci\xf3n en directo:",
    'fabric.editor.ai.screens.loading.iconAltText': 'Generando icono',
    'fabric.editor.ai.screens.preview.betaLabel': 'Beta',
    'fabric.editor.ai.screens.preview.cancelLabel': 'Cancelar',
    'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'Dile a AI lo que quieres que haga ahora',
    'fabric.editor.ai.screens.preview.discardLabel': 'Descartar',
    'fabric.editor.ai.screens.preview.disclaimer': "La calidad de la informaci\xf3n puede variar.",
    'fabric.editor.ai.screens.preview.disclaimerLink': "Descubre por qu\xe9",
    'fabric.editor.ai.screens.preview.header.clear.hover': 'Borrar',
    'fabric.editor.ai.screens.preview.header.edit': 'Editar mensaje',
    'fabric.editor.ai.screens.preview.header.edit.hover': 'Editar',
    'fabric.editor.ai.screens.preview.placeholderWithAgent': "Preg\xfantale a {agentName} qu\xe9 hacer a continuaci\xf3n",
    'fabric.editor.ai.screens.preview.refineButton': 'Refinar',
    'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Refinar',
    'fabric.editor.ai.screens.prompt.logoAltText': 'Logotipo de Atlassian Intelligence',
    'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
    'fabric.editor.ai.screens.prompt.submitLabel': 'Enviar',
    'fabric.editor.ai.screens.prompt.submitTooltip': 'Enviar a AI',
    'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': 'Seleccionado: {promptName}',
    'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Eliminar',
    'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Sugerencias',
    'fabric.editor.ai.shared.aiUniversalDescriptor': "Asistente de redacci\xf3n",
    'fabric.editor.ai.shared.aiUniversalLongCallToAction': 'Deja que Atlassian Intelligence te ayude a redactar',
    'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Escribir',
    'fabric.editor.ai.shared.betaLabel': 'Beta',
    'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
    'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BETA',
    'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NOVEDAD',
    'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Dile a AI',
    'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': 'Dile al agente'
};

});


//# sourceMappingURL=es.9f403665.js.map
